import { createFetchedData, LoadingState } from '@vista-digital/utilities';
export const defaultMemberJourneysState = {
    current: createFetchedData(LoadingState.NotLoaded),
    past: createFetchedData(LoadingState.NotLoaded)
};
//# sourceMappingURL=member-journeys-state.js.map